import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=010d2a84&scoped=true&"
import script from "./lang.vue?vue&type=script&lang=js&"
export * from "./lang.vue?vue&type=script&lang=js&"
import style0 from "./lang.vue?vue&type=style&index=0&id=010d2a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d2a84",
  null
  
)

export default component.exports